import { TableComponent } from "../../components/templates/TableComponent.tsx";

export default function TemplatesPage() {
  return (
    <div className="w-full h-full p-14">
      <TableComponent />
    </div>
  );
}
